// import moment from "moment";
import config from "../config/config";
import { utcToLocal } from "./DateHelper";
import { decryptData, encryptData } from "./EncryptHelper";
import dateFormat from "dateformat";

export const numberToOrdinal = (number) => {
  const remainder10 = number % 10;
  const remainder100 = number % 100;

  if (remainder10 === 1 && remainder100 !== 11) {
    return `${number}st`;
  } else if (remainder10 === 2 && remainder100 !== 12) {
    return `${number}nd`;
  } else if (remainder10 === 3 && remainder100 !== 13) {
    return `${number}rd`;
  } else {
    return `${number}th`;
  }
};

export const getInitials = (name) => {
  const initials = name
    .split(" ")
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();

  return initials;
};

export const profilePic = (
  firstName,
  lastName,
  pic,
  radius = "30px",
  fontSize = "10px",
  display = "block"
) => {
  if (display !== "block") {
    return "";
  } else if (pic) {
    return <img src={`${process.env.REACT_APP_ASSETS_URL}/${pic}`} alt="img" />;
  } else {
    let name = firstName + " " + lastName;

    return (
      <div className="user-avatar" style={{ height: radius, width: radius, fontSize: fontSize }}>
        {getInitials(name)}
      </div>
    );
  }
};

export const checkPermission = (route, action = 'view') => {
  const user_data = localStorage.getItem("user_data") ? (decryptData(localStorage.getItem("user_data")) ?? {}) : {};

  return user_data.urole_permission?.[route]?.[action] ?? false;
};

/** User list / profile row: Super Admin is `_urole_id === 1` (also title/type fallbacks). */
export const isSuperAdminUser = (row) => {
  if (!row || typeof row !== "object") {
    return false;
  }
  if (row._urole_id == 1 || row.user_role_id == 1) {
    return true;
  }
  if (row.urole_type === "super_admin") {
    return true;
  }
  const title = String(row.urole_title ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
  return title === "super admin";
};

export const formatDataBeforeSend = (data, inputFields, formatOptions) => {
  const filterData = {};
  // Object.keys(inputFields).forEach(function(item, val) {
  //   filterData[item] = data[item] ?? null;
  //   console.log('item  =>',item + ' ' + val);
  // });
  Object.entries(inputFields).forEach(([key, value], index) => {
    filterData[key] = value ? value : data[key] ? data[key] : ''; // Assign the value to `filterData`
    //console.log(`Index: ${index}, Key: ${key}, Value: ${value}`);
  });
  //console.log('data  =>',data);
  //console.log('inputFields  =>',inputFields);
  //console.log('filterdata 1 =>',filterData);
  if (formatOptions) {
    formatOptions.forEach(function(item) {
      if (item.type == 'react-select') {
        filterData[item.column] = filterData[item.column]?.value ?? '';
      } else if (item.type == 'react-select-multiple') {
        let temp = [];
        filterData[item.column]?.forEach(function(val) {
          temp.push(val.value);
        });
        filterData[item.column] = temp.join(',');
      } else if (item.type == 'react-datepicker') {
        filterData[item.column] = filterData[item.column] ? dateFormat(filterData[item.column], "dd-mm-yyyy") : '';
      } else if (item.type == 'react-timepicker') {
        const raw = filterData[item.column];
        if (
          !raw ||
          raw === '00:00:00' ||
          (typeof raw === 'string' && raw.includes('NaN'))
        ) {
          filterData[item.column] = '';
        } else if (raw instanceof Date && !isNaN(raw.getTime())) {
          const hours = String(raw.getHours()).padStart(2, '0');
          const minutes = String(raw.getMinutes()).padStart(2, '0');
          const seconds = String(raw.getSeconds()).padStart(2, '0');
          filterData[item.column] = `${hours}:${minutes}:${seconds}`;
        } else if (typeof raw === 'string') {
          const trimmed = raw.trim();
          const match24 = trimmed.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
          if (match24) {
            filterData[item.column] = `${String(match24[1]).padStart(2, '0')}:${match24[2]}:${match24[3] || '00'}`;
          } else {
            // Handles values like "2:30 PM" from react-time-picker
            const now = new Date(Date.parse('2024-01-01 ' + trimmed));
            if (isNaN(now.getTime())) {
              filterData[item.column] = '';
            } else {
              const hours = String(now.getHours()).padStart(2, '0');
              const minutes = String(now.getMinutes()).padStart(2, '0');
              const seconds = String(now.getSeconds()).padStart(2, '0');
              filterData[item.column] = `${hours}:${minutes}:${seconds}`;
            }
          }
        } else {
          filterData[item.column] = '';
        }
      } else if (item.type == 'file' && filterData[item.column] == null) {
        filterData[item.column] = '';
      }
      // else if(item.type='hidden'){
      //   filterData[item.column] = filterData[item.labelColumn] ? filterData[item.labelColumn] : filterData[item.column];
      // }
    });
  }
  //console.log('filterdata2 =>',filterData);
  let formData = new FormData();
  for (let key in filterData) {
    formData.append(key, filterData[key]);
  }

  return formData;
}

export const formatDataBeforeDisplay = (data, formatOptions) => {
  const formData = JSON.parse(JSON.stringify(data));

  Object.keys(formData).forEach(function(item) {
    formData[item] = data[item] ?? '';
  });
//console.log('form =>',formData);
  if (formatOptions) {
    formatOptions.forEach(function(item) {
      if (item.type == 'react-select') {
        formData[item.column] = { value: formData[item.column], label: formData[item.labelColumn] };
      } else if (item.type == 'react-datepicker') {
        if (! formData[item.column] || formData[item.column] == '0000-00-00') {
          formData[item.column] = null;
        } else {
          formData[item.column] = new Date(Date.parse(formData[item.column]));
        }
      } else if (item.type == 'react-timepicker') {
        // Keep HH:mm:ss strings for react-time-picker (avoid Date → NaN on re-save)
        const raw = formData[item.column];
        if (
          !raw ||
          raw === '00:00:00' ||
          (typeof raw === 'string' && String(raw).includes('NaN'))
        ) {
          formData[item.column] = null;
        } else if (typeof raw === 'string') {
          const match24 = raw.trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
          if (match24) {
            formData[item.column] = `${String(match24[1]).padStart(2, '0')}:${match24[2]}:${match24[3] || '00'}`;
          } else {
            const parsed = new Date(Date.parse('2024-01-01 ' + raw));
            if (isNaN(parsed.getTime())) {
              formData[item.column] = null;
            } else {
              const hours = String(parsed.getHours()).padStart(2, '0');
              const minutes = String(parsed.getMinutes()).padStart(2, '0');
              const seconds = String(parsed.getSeconds()).padStart(2, '0');
              formData[item.column] = `${hours}:${minutes}:${seconds}`;
            }
          }
        } else {
          formData[item.column] = null;
        }
      }
    });
  }

  return formData;
}

export const formatDataBeforeView = (data, formatOptions) => {
  const formData = JSON.parse(JSON.stringify(data));

  Object.keys(formData).forEach(function(item) {
    formData[item] = data[item] ?? '';
  });

  if (formatOptions) {
    formatOptions.forEach(function(item) {
      if (item.type == 'date') {
        if (! formData[item.column] || formData[item.column] == '0000-00-00') {
          formData[item.column] = '';
        } else {
          formData[item.column] = dateFormat(Date.parse(formData[item.column]), 'dd/mm/yyyy');
        }
      } else if (item.type == 'time') {
        if (! formData[item.column] || formData[item.column] == '00:00:00') {
          formData[item.column] = '';
        } else {
          formData[item.column] = formatAMPM(new Date(Date.parse('2024-04-30 ' + formData[item.column])));
        }
      } else if (item.type == 'datetime') {
        if (! formData[item.column] || formData[item.column] == '0000-00-00 00:00:00') {
          formData[item.column] = '';
        } else {
          formData[item.column] = utcToLocal(formData[item.column]);
        }
      } else if (item.type == 'yesNo') {
        formData[item.column] = formData[item.column] == 1 ? 'Yes' : 'No';
      } else if (item.type == 'capitalize') {
        formData[item.column] = capitalize(formData[item.column]);
      }
    });
  }

  return formData;
}

export const cacheToStorage = (key, data) => {
  if (! config.isCache) {
    return;
  }

  let currentTime = dateFormat('', "dd mmm yyyy HH:MM:ss");

  const dataToStore = {
      [key]: data,
      time:currentTime
  };

  localStorage.setItem(key, encryptData(dataToStore));
}

export const validorSettings = () => {
  return {
    messages: {
      max: 'The :attribute must be at most :max digits',
      min: 'The :attribute must be at least :min digits',

      // email: 'Please enter an valid email',
      // url: 'Please enter an valid URL',
      // default: 'Validation has failed!'
    },
    autoForceUpdate: this
  }
}

export const quickAddClient = {
  url: 'clients/add',
  responseKey: 'clients',
  valueCol: '_client_id',
  labelCol: 'client_name',
  fields: [
    { type: 'Text', name: 'client_name', label: 'Client Name', required: true },
    { type: 'Text', name: 'client_website', label: 'Website' },
    { type: 'TextArea', name: 'client_address', label: 'Address' },
    { type: 'TextArea', name: 'client_remarks', label: 'Remarks' },
  ]
};

export const quickAddContact = {
  url: 'contacts/add',
  responseKey: 'client_contacts',
  valueCol: '_contact_id',
  labelCol: 'contact_name',
  dependedColumn: 'contact_client_id',
  fields: [
    { type: 'Text', name: 'contact_name', label: 'Manager Name', required: true },
    { type: 'MyReactSelect', name: 'contact_client_id', label: 'Client', required: true, options: 'clients/list._client_id.client_name', responseKey: 'clients' },
    { type: 'Text', name: 'contact_mobile', label: 'Contact Number', required: true },
    { type: 'TextEmail', name: 'contact_email', label: 'Email', required: true },
    { type: 'Text', name: 'contact_designation', label: 'Designation' },
  ]
};

export const quickAddManager = () => {
  // const optionsGender = [
  //   { value: 'male', label: 'Male' },
  //   { value: 'female', label: 'Female' },
  //   { value: 'other', label: 'Other' },
  // ];

  return {
    url: 'users/add-user',
    responseKey: 'users',
    valueCol: '_user_id',
    labelCol: ['user_first_name', 'user_last_name'],
    fields: [
      { type: 'Text', name: 'user_first_name', label: 'First Name', required: true },
      { type: 'Text', name: 'user_last_name', label: 'Last Name', required: true },
      // { type: 'DatePicker', name: 'user_dob', label: 'Date of Birth', required: true },
      // { type: 'MySelect', name: 'user_gender', label: 'Gender', required: true, options: optionsGender },
      { type: 'Text', name: 'user_mobile', label: 'Mobile', required: true },
      { type: 'TextEmail', name: 'user_email', label: 'Email', required: true },
      { type: 'MyReactSelect', name: 'user_role_id', label: 'User Role', required: true, options: 'users/user_role_list?urole_type=manager._urole_id.urole_title', responseKey: 'user_roles' },
      { type: 'TextPassword', name: 'user_password', label: 'Password', required: true },
    ]
  }
};

export const quickAddRecruiter = () => {
  // const optionsGender = [
  //   { value: 'male', label: 'Male' },
  //   { value: 'female', label: 'Female' },
  //   { value: 'other', label: 'Other' },
  // ];

  return {
    url: 'users/add-user',
    responseKey: 'users',
    valueCol: '_user_id',
    labelCol: ['user_first_name', 'user_last_name'],
    dependedColumn: 'user_manager_id',
    fields: [
      { type: 'Text', name: 'user_first_name', label: 'First Name', required: true },
      { type: 'Text', name: 'user_last_name', label: 'Last Name', required: true },
      // { type: 'DatePicker', name: 'user_dob', label: 'Date of Birth', required: true },
      // { type: 'MySelect', name: 'user_gender', label: 'Gender', required: true, options: optionsGender },
      { type: 'Text', name: 'user_mobile', label: 'Mobile', required: true },
      { type: 'TextEmail', name: 'user_email', label: 'Email', required: true },
      { type: 'MyReactSelect', name: 'user_manager_id', label: 'Manager', required: true, options: 'users/get-managers._user_id.manager_name', responseKey: 'managers' },
      { type: 'MyReactSelect', name: 'user_role_id', label: 'User Role', required: true, options: 'users/user_role_list?urole_type=recruiter._urole_id.urole_title', responseKey: 'user_roles' },
      { type: 'TextPassword', name: 'user_password', label: 'Password', required: true },
    ]
  }
};

// export const quickAddRequirement = {
//   url: 'requirements/add',
//   responseKey: 'requirements',
//   valueCol: '_requirement_id',
//   labelCol: 'requirement_name',
//   dependedColumn: 'requirement_client_id',
//   fields: [
//     { type: 'Text', name: 'requirement_name', label: 'Manager Name', required: true },
//     { type: 'MyReactSelect', name: 'requirement_client_id', label: 'Client', required: true, options: 'clients/list._client_id.client_name', responseKey: 'clients' },
//     // { type: 'MyReactSelect', name: 'requirement_contact_id', label: 'POC', required: true, options: [] },
//     { type: 'MyReactSelect', name: 'requirement_manager_id', label: 'Manager', required: true, options: 'users/get_managers._user_id.user_mobile', responseKey: 'managers' },
//     // { type: 'MyReactSelect', name: 'requirement_recruiter_id', label: 'Recruiter', required: true },
//     { type: 'TextNumber', name: 'requirement_no_of_positions', label: 'No. of Positions' },
//     { type: 'Text', name: 'requirement_location', label: 'Location' },
//   ]
// };

export const quickAddSkill = {
  url: 'skills/add',
  responseKey: 'skills',
  valueCol: '_skill_id',
  labelCol: 'skill_name',
  fields: [
    { type: 'Text', name: 'skill_name', label: 'Skill Name', required: true },
  ]
};

export const formatAMPM = (date) => {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0'+minutes : minutes;

  return hours + ':' + minutes + ' ' + ampm;
}

export const capitalize = (value) => {
  if (! value)
    return '';

  return value.charAt(0).toUpperCase() + value.slice(1);
}

export const decodeHtmlEntities = (encodedString) => {
  const elem = document.createElement('textarea');
elem.innerHTML = encodedString;
return elem.value;
}

export const paymentModeLabels = (payment_mode) => {

  if (payment_mode=='bank-transfer') {
      return 'Bank Transfer';
  }
  else if (payment_mode=='cash') {
      return 'Cash';
  }
  else if (payment_mode=='cheque') {
      return 'Cheque';
  }
  else{
      return '';
  }

} 